import { makeStyles } from '@material-ui/core'
import themesConfig from 'app/fuse-configs/themesConfig'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  dialogWrap: {
    '& .MuiPaper-root': {
      padding: '85px 83px',
      maxWidth: 482,
      [useBreakpoints(theme).lessThan.sm]: {
        padding: 20,
      },
      borderRadius: 16,
    },
  },

  cancelImportBtn: {
    fontSize: 16,
    color: themesConfig.default.colors['red-600'],
  },
}))
